export default "__VITE_ASSET__BfUCDF2U__"